/** @jsx jsx */
import { Status, StatusVariant } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { JobApplicationStatus } from "@/data/job-applications/types/JobApplicationStatus";
import { useCodelistTranslation } from "@/hooks/Codelist";

const mapStatusToStatusVariant: Record<JobApplicationStatus, StatusVariant> = {
  DRAFT: "secondary",
  SUBMITTED: "info",
  PRESENTED_TO_CLIENT: "info",
  INTERVIEW: "info",
  ACCEPTED: "success",
  WITHDRAWN: "danger",
  REJECTED: "danger",
  EXPIRED: "danger",
  DELETED: "danger",
  IN_REVIEW: "info",
};

interface JobApplicationStatusProps {
  status: JobApplicationStatus;
}

export const JobApplicationStatusComponent: FC<JobApplicationStatusProps> = ({ status }) => {
  const tCodelist = useCodelistTranslation();

  const variant = mapStatusToStatusVariant[status];

  return <Status variant={variant}>{tCodelist("job-request-application-statuses", status)}</Status>;
};
